import { render } from "./ExternalSearchResultInfo.vue?vue&type=template&id=4f87b9ea&ts=true"
import script from "./ExternalSearchResultInfo.vue?vue&type=script&lang=ts"
export * from "./ExternalSearchResultInfo.vue?vue&type=script&lang=ts"

import "./ExternalSearchResultInfo.vue?vue&type=style&index=0&id=4f87b9ea&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__